import React from 'react';
import { useBranchQuery } from '../../features/branch/branchApiSlice';

const GetBranchName = ({ branchId }) => {
  const {
    data: branchs,
    error: branchErr,
    isLoading: branchLoading,
    isFetching: branchFetching,
    isSuccess: branchSuccess,
  } = useBranchQuery({ refetchOnMountOrArgChange: true });

  const getBranchName = (branchid) => {
    if (branchSuccess) {
      const filterdata = branchs?.data.filter((branch) => {
        return branch.id == branchid;
      });
      return filterdata[0]?.name;
    }
  };

  return <>{getBranchName(branchId)}</>;
};

export default GetBranchName;
